import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { Link } from "react-router-dom";
import Chip from "@mui/material/Chip";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function Portfolio() {
  const { t } = useTranslation();
  return (
    <Box sx={{ maxWidth: 720, margin: "0 auto" }}>
      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          overflow: "hidden",
          border: "1px solid #E2E8F0",
          transition: "box-shadow 0.2s ease, transform 0.2s ease",
          "&:hover": {
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
            transform: "translateY(-2px)",
          },
        }}
      >
        {/* Thumbnail */}
        <Box
          sx={{
            width: { xs: "100%", sm: 200 },
            minHeight: { xs: 180, sm: "auto" },
            flexShrink: 0,
            backgroundImage: `url(${process.env.PUBLIC_URL}/picdict.webp)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "#F8FAFC",
          }}
        />

        <CardContent
          sx={{
            flex: 1,
            p: { xs: 3, md: 4 },
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          <Box>
            <Chip
              label="App"
              size="small"
              sx={{
                backgroundColor: "#EFF6FF",
                color: "#3B82F6",
                fontWeight: 600,
                fontSize: "0.7rem",
                mb: 1,
                height: 22,
              }}
            />
            <Link to="/picdict/about" style={{ textDecoration: "none" }}>
              <Typography
                variant="h5"
                component="div"
                sx={{
                  fontWeight: 700,
                  color: "#0F172A",
                  fontSize: "1.15rem",
                  "&:hover": { color: "#3B82F6" },
                  transition: "color 0.15s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                {t("home.portfolio.title")}
                <ArrowForwardIcon sx={{ fontSize: "1rem", opacity: 0.5 }} />
              </Typography>
            </Link>
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.8, fontSize: "0.88rem" }}
          >
            {t("home.portfolio.description")}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
